import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import InputField from "components/fields/InputField";
import Checkbox from "components/checkbox";
import { login } from "api/auth";
import { useAuthStore } from "store/authStore";

export default function SignIn() {
  const navigate = useNavigate();
  const setTokens = useAuthStore((s) => s.setTokens);
  const [loading, setLoading] = useState(false);

  const handleSignIn = async (e: React.FormEvent) => {
    e.preventDefault();

    const emailEl = document.getElementById("email") as HTMLInputElement | null;
    const passwordEl = document.getElementById("password") as HTMLInputElement | null;
    const email = emailEl?.value?.trim();
    const password = passwordEl?.value;

    if (!email || !password) {
      toast.error("Please enter email and password");
      return;
    }

    if (password.length < 8) {
      toast.error("Password must be at least 8 characters");
      return;
    }

    setLoading(true);
    try {
      const { accessToken, refreshToken } = await login({ email, password });
      setTokens(accessToken, refreshToken);
      navigate("/dashboard/home");
    } catch (err) {
      toast.error(err instanceof Error ? err.message : "Sign in failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSignIn} className="flex w-full flex-col items-center justify-center">
      <div className="w-full">
        <h4 className="mb-2.5 text-xl font-bold tracking-wider text-[#222]">
          Sign In
        </h4>
        <p className="mb-9 ml-1 text-sm text-[#6D6D6D]">
          Enter your email and password to sign in!
        </p>

        <InputField
          variant="auth"
          extra="mb-3"
          label="Email*"
          placeholder="mail@simmmple.com"
          id="email"
          type="email"
        />

        <InputField
          variant="auth"
          extra="mb-3"
          label="Password*"
          placeholder="Min. 8 characters"
          id="password"
          type="password"
        />

        <div className="mb-4 flex items-center justify-between px-2">
          <div className="flex items-center">
            <Checkbox color="navy" />
            <p className="ml-2 text-sm font-medium text-[#222]">
              Keep me logged In
            </p>
          </div>
          <Link
            className="text-sm font-medium text-[#6D6D6D] hover:text-[#222]"
            to="/auth/forgot-password"
          >
            Forgot Password?
          </Link>
        </div>
        <button
          type="submit"
          disabled={loading}
          className="mt-2 w-full rounded-md bg-[#222] py-2.5 text-xs font-semibold text-white transition duration-200 hover:bg-[#333] active:bg-[#111] disabled:opacity-60"
        >
          {loading ? "Signing in..." : "Sign In"}
        </button>
      </div>
    </form>
  );
}
